/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface MarkPatientProgramAsDeleted$Params {
  patientProgramID?: number;
  propagate?: boolean;
}

export function MarkPatientProgramAsDeleted(http: HttpClient, rootUrl: string, params?: MarkPatientProgramAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, MarkPatientProgramAsDeleted.PATH, 'post');
  if (params) {
    rb.query('patientProgramID', params.patientProgramID, {});
    rb.query('propagate', params.propagate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

MarkPatientProgramAsDeleted.PATH = '/api/Supervisor/MarkPatientProgramAsDeleted';
